import React from 'react';

import { SVGComponentProps } from './svg.types';

const EmbedSVG = ({ size = '1em', ...otherProps }: Omit<SVGComponentProps, 'wrapperClass'>) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <rect x="0.5" y="0.5" width="35" height="35" rx="1.5" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.3333 27.75L26.3333 8.25C26.3333 7.35254 25.5871 6.625 24.6667 6.625L11.3333 6.625C10.4129 6.625 9.66666 7.35254 9.66666 8.25L9.66666 27.75C9.66666 28.6475 10.4129 29.375 11.3333 29.375L24.6667 29.375C25.5871 29.375 26.3333 28.6475 26.3333 27.75ZM28 8.25C28 6.45507 26.5076 5 24.6667 5L11.3333 5C9.49238 5 8 6.45507 8 8.25L8 27.75C8 29.5449 9.49238 31 11.3333 31L24.6667 31C26.5076 31 28 29.5449 28 27.75L28 8.25Z"
        fill="#BCBEC2"
      />
      <path
        d="M14.8404 19.4871C15.2995 19.4859 15.7411 19.3202 16.0774 19.0231L19.3628 20.8079C19.1353 21.6533 19.595 22.5293 20.4424 22.8648C21.2897 23.2003 22.2675 22.8934 22.7383 22.1443C23.2091 21.3952 23.0301 20.4311 22.318 19.8806C21.6058 19.3301 20.5765 19.3602 19.9013 19.9512L16.6159 18.1664C16.6503 18.0411 16.6694 17.9125 16.6726 17.7832L19.9008 16.0293C20.5415 16.5831 21.5027 16.6344 22.2047 16.1523C22.9067 15.6703 23.1575 14.7865 22.8059 14.0342C22.4542 13.2818 21.5963 12.8665 20.7495 13.0387C19.9027 13.2109 19.2985 13.9236 19.3014 14.7469C19.3033 14.8906 19.3239 15.0336 19.3628 15.1725L16.3797 16.7927C15.9019 16.0898 14.9668 15.8081 14.1503 16.121C13.3339 16.4339 12.8657 17.2534 13.0341 18.0748C13.2025 18.8963 13.9602 19.4887 14.8404 19.4871Z"
        fill="#55585E"
      />
      <rect x="0.5" y="0.5" width="35" height="35" rx="1.5" stroke="#D5D7DD" />
    </svg>
  );
};

export default EmbedSVG;
